import { take, fork, all } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './studentSimulatedActions';

export const getEvaluations = apiTask(
  actions.GET_EVALUATIONS,
  api.post,
  '/evaluation-system-student/getEvaluations.php',
);

export const getESFiltersComponentsTask = watchApiTask(
  actions.GET_ES_FILTERS_COMPONENTS,
  api.post,
  '/evaluation-system/getESFiltersComponents.php',
);

export const getESGradeByDisciplineTask = watchApiTask(
  actions.GET_ESGRADE_BY_DISCIPLINE,
  api.post,
  '/evaluation-system/getESGradeByDiscipline.php',
);

export const getESGradeReportStudentTask = watchApiTask(
  actions.GET_ESGRADE_REPORT_STUDENT,
  api.post,
  '/evaluation-system/getESGradeReportStudent.php',
);

export const getESQuestionsDetailsByComponentsTask = watchApiTask(
  actions.GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS,
  api.post,
  '/evaluation-system/getESQuestionsDetailsByComponents.php',
);

export const getESGradeDetailAlternativeReportTask = watchApiTask(
  actions.GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT,
  api.post,
  '/evaluation-system/getESGradeDetailAlternativeReport.php',
);

export const getESEvaluationsCicleStudentTask = watchApiTask(
  actions.GET_ES_EVALUATIONS_CICLE_STUDENT,
  api.post,
  '/evaluation-system/getESEvaluationsCicleStudent.php',
);

export const getESGradeDetailByStudentTask = watchApiTask(
  actions.GET_ESGRADE_DETAIL_BY_STUDENT,
  api.post,
  '/evaluation-system/getESGradeDetailByStudent.php',
);

export const getESGradeStudentQuestionsTask = watchApiTask(
  actions.GET_ESGRADE_STUDENT_QUESTIONS,
  api.post,
  '/evaluation-system/getESGradeStudentQuestions.php',
);

export const getGroupsTask = watchApiTask(
  actions.GET_GROUPS,
  api.post,
  '/evaluation-system/getGroups.php',
);

export const getESQuestionDetailTask = watchApiTask(
  actions.GET_ES_QUESTION_DETAIL,
  api.post,
  '/evaluation-system-student/getESQuestionDetail.php',
);

export function* watchGetEvaluations() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATIONS);
    yield fork(getEvaluations, payload);
  }
}

export function* watchGenerateBatchPdfTask() {
  while (true) {
    const { payload } = yield take(actions.GENERATE_BATCH_PDF);
    const { resolve, reject } = payload;
    yield put(action(request(actions.GENERATE_BATCH_PDF)));
    try {
      const { data } = yield call(nodeApi.post, '/reports/capture/pdf/multiple', payload, {
        responseType: 'blob',
      });
      if (data && data instanceof Blob) {
        yield put(action(success(actions.GENERATE_BATCH_PDF)));
        saveAs(data, payload.filename);
      }
      resolve && resolve();
    } catch (error) {
      yield put(action(failure(actions.GENERATE_BATCH_PDF)));
      reject && reject(error);
    }
  }
}

export const getEssaySsoUrlTask = watchApiTask(
  actions.GET_ESSAY_SSO_URL,
  api.post,
  '/evaluation-system/generateEssaySsoUrl.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(watchGetEvaluations),
    fork(watchGenerateBatchPdfTask),
    fork(getESFiltersComponentsTask),
    fork(getESGradeByDisciplineTask),
    fork(getESGradeReportStudentTask),
    fork(getESQuestionsDetailsByComponentsTask),
    fork(getESGradeDetailAlternativeReportTask),
    fork(getESEvaluationsCicleStudentTask),
    fork(getESGradeDetailByStudentTask),
    fork(getESGradeStudentQuestionsTask),
    fork(getGroupsTask),
    fork(getESQuestionDetailTask),
    fork(getEssaySsoUrlTask),
  ]);
}
